(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pasek-promocyjny"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var selectedSectionId = null;

    function pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    function updateCountdowns() {
      document.querySelectorAll('[data-promo-deadline]').forEach(function (root) {
        var left = Math.max(0, Number(root.getAttribute('data-promo-deadline')) - Date.now());
        var values = {
          d: Math.floor(left / 864e5),
          h: pad(Math.floor((left % 864e5) / 36e5)),
          m: pad(Math.floor((left % 36e5) / 6e4)),
          s: pad(Math.floor((left % 6e4) / 1e3))
        };

        root.querySelectorAll('[data-unit]').forEach(function (unit) {
          unit.textContent = values[unit.getAttribute('data-unit')];
        });

        if (left === 0 && !root.hasAttribute('data-design-mode')) {
          root.style.display = 'none';
        }
      });
    }

    function initPopup(popup) {
      if (popup.promoReady) return;
      popup.promoReady = true;

      if (popup.parentElement !== document.body) {
        document.body.appendChild(popup);
      }

      var lastFocused = null;

      popup.promoOpen = function () {
        lastFocused = document.activeElement;
        popup.querySelectorAll('img[loading="lazy"]').forEach(function (image) {
          image.loading = 'eager';
        });
        popup.classList.add('is-open');
        var closeButton = popup.querySelector('[data-promo-close]');
        if (closeButton) closeButton.focus({ preventScroll: true });
      };

      popup.promoClose = function () {
        if (!popup.classList.contains('is-open')) return;
        popup.classList.remove('is-open');
        if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
      };

      popup.addEventListener('click', function (event) {
        if (event.target === popup || event.target.closest('[data-promo-close]')) popup.promoClose();
      });

      if (popup.hasAttribute('data-design-mode')) return;
      if (popup.hasAttribute('data-hide-mobile') && window.matchMedia('(max-width: 640px)').matches) return;
      if (popup.hasAttribute('data-hide-tablet') && window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

      var deadline = Number(popup.getAttribute('data-promo-deadline') || 0);
      if (deadline && deadline <= Date.now()) return;

      var storageKey = popup.getAttribute('data-storage-key');
      var frequencyMs = Number(popup.getAttribute('data-frequency') || 7) * 864e5;
      var delayMs = Number(popup.getAttribute('data-delay') || 0) * 1000;

      try {
        var lastShown = Number(localStorage.getItem(storageKey) || 0);
        if (lastShown && Date.now() - lastShown < frequencyMs) return;
      } catch (error) {}

      setTimeout(function () {
        popup.promoOpen();
        try {
          localStorage.setItem(storageKey, String(Date.now()));
        } catch (error) {}
      }, delayMs);
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-promo-popup]').forEach(initPopup);
      updateCountdowns();
    }

    function popupFor(sectionId) {
      return document.getElementById('PromoPopup-' + sectionId);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-promo-popup].is-open').forEach(function (popup) {
        popup.promoClose();
      });
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var popup = popupFor(event.detail.sectionId);
      if (popup) popup.remove();
    });

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
      var popup = popupFor(event.detail.sectionId);
      if (popup && event.detail.sectionId === selectedSectionId) popup.promoOpen();
    });

    document.addEventListener('shopify:section:select', function (event) {
      selectedSectionId = event.detail.sectionId;
      var popup = popupFor(event.detail.sectionId);
      if (popup && popup.promoOpen) popup.promoOpen();
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      if (selectedSectionId === event.detail.sectionId) selectedSectionId = null;
      var popup = popupFor(event.detail.sectionId);
      if (popup && popup.promoClose) popup.promoClose();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    setInterval(updateCountdowns, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
